import {GetterTree, MutationTree, Module, ActionTree} from 'vuex'
import {RootState, EssaiState} from '../types'
import {apiUrl} from '@/config/service'
import axios from 'axios'

type EssaiGetter = GetterTree<EssaiState, RootState>

const state: EssaiState = {
  count: null,
  essai: null
}

export const getters: EssaiGetter = {
  essaisCountGetter: (state) => state.count,
  essaiGetter: (state) => state.essai
}

export const actions: ActionTree<EssaiState, RootState> = {
  async getEssaisCountAction({commit}) {
    const {data} = await axios.get(`${apiUrl}/essai/count`)
    commit('getEssaisCountMutation', data)
    return data
  },
  async getEssaiByIdAction({commit}, id) {
    commit('resetEssaiMutation')
    const {data} = await axios.get(`${apiUrl}/essai/${id}`)
    commit('getEssaiByIdMutation', data)
    return data
  },
  async createEssaiAction({commit}, formParams) {
    const {data} = await axios.post(`${apiUrl}/essai`, formParams)
    return data
  },
  async updateEssaiAction({commit}, {id, formParams}) {
    const {data} = await axios.put(`${apiUrl}/essai/${id}`, formParams)
    return data
  },
  async deleteEssaiAction({commit}, id) {
    const {data} = await axios.delete(`${apiUrl}/essai/${id}`)
    return id
  },
  async updateEssaiStatutAction({commit}, {id, statut}) {
    const {data} = await axios.put(`${apiUrl}/essai/${id}/updateStatut`, {
      CODE_REF_STATUT_ESSAI: statut
    })
    return data
  }
}

const mutations: MutationTree<EssaiState> = {
  getEssaisCountMutation(state, data) {
    state.count = data.count
  },
  getEssaiByIdMutation(state, data) {
    state.essai = data
  },
  resetEssaiMutation(state) {
    state.essai = null
  }
}

export const essai: Module<EssaiState, RootState> = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
